import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import Chevron from '@alltrails/denali/icons/Chevron';
import styles from './styles.module.scss';

type ShowMoreCardProps = {
  url: string;
  cardIndex: number;
};

const ShowMoreCard = ({ url }: ShowMoreCardProps) => {
  return (
    <a href={url} className={styles.container}>
      <div className={styles.showMore}>
        <Typography variant="text200bold">
          <FormattedMessage defaultMessage="Show more" />
        </Typography>
        <Chevron orientation="right" color="currentColor" />
      </div>
    </a>
  );
};

export default ShowMoreCard;
